module.exports = __webpack_public_path__ + "static/logo_cway-329b3c11c96446243918c52f817ac214.png";